/**
 * CHẤM CÔNG (05/10/2026, chủ dự án: «thiết kế bảng chấm công và bảng thiết kế giờ chấm công giống như
 * chuông báo giờ chấm công»). Luật dùng chung cho máy chủ (ghi lần chấm, chuông nhắc NGƯỜI CHƯA CHẤM)
 * và web (thẻ chấm công, bảng chấm công ngày / tháng, Cài đặt › Giờ chấm công).
 *
 *  • Nhân viên bấm «Chấm công» → máy chủ ghi giờ CỦA MÁY CHỦ, không tin đồng hồ máy người dùng.
 *  • Mỗi ngày có vài MỐC CHẤM CÔNG do Giám đốc đặt (mặc định 08:30 «Vào làm», đúng giờ chuông đặt hôm
 *    03/10): mốc VÀO mà chấm sau giờ của mốc quá số phút cho phép là ĐI MUỘN; mốc RA mà chấm trước giờ
 *    của mốc là VỀ SỚM.
 *  • Từ 07/10/2026 (bản bàn giao «Chấm công qua Wi-Fi công ty»): người chấm bấm hẳn «Vào ca» hay «Ra ca»,
 *    lần chấm mang loại ấy và chỉ về mốc cùng loại; trễ / sớm tính tới giây, làm tròn lên phút. Lần chấm bản
 *    cũ (không loại) chia theo giờ: ranh giới giữa hai mốc kề nhau là điểm giữa của chúng — đúng cách máy
 *    chấm công vân tay vẫn làm. Mốc vào lấy lần chấm SỚM NHẤT, mốc ra lấy lần MUỘN NHẤT; bấm nhầm hai lần
 *    không làm sai gì.
 *  • Chuông của mốc (thay cho dòng «Chấm công» 8h30 ở Lịch nhắc) chỉ đổ ở máy NGƯỜI CHƯA CHẤM mốc ấy.
 *  • Quản lý ĐÁNH DẤU được từng ngày của người trong phạm vi: có đi làm (chấm bù), nghỉ phép, nghỉ không
 *    phép, công tác, nghỉ lễ — dấu tay thắng mọi lần chấm của ngày đó.
 *  • Chỉ chấm được bằng APP trên ĐIỆN THOẠI, trong MẠNG CÔNG TY (cả hai Giám đốc tắt / khai ở Cài đặt).
 *
 * Lưu trong bản ghi cài đặt chung, khoá `chamCong`. Khoá VẮNG MẶT = chưa ai sửa → dùng mặc định.
 */
import { normalizeNetwork } from './networks.js';
import { isPersonnel } from './roles.js';
import { minutesInSession } from './requests.js';
export const ATTENDANCE_SETTING_KEY = 'chamCong';
/** Tên hai nút chấm công theo bản bàn giao 07/10/2026 («ẤN ĐỂ VÀO CA NGAY» · «ẤN ĐỂ RA CA (TAN LÀM)»). */
export const ATTENDANCE_KIND_LABELS = {
    in: 'Vào ca',
    out: 'Ra ca',
};
/**
 * Ngày app bắt đầu chấm công: chức năng lên VPS sáng thứ Hai 05/10/2026, lúc đã qua giờ vào làm, nên tính
 * từ ngày làm việc kế tiếp. Giám đốc đổi được ở Cài đặt › Giờ chấm công.
 */
export const ATTENDANCE_START_DAY = '2026-10-06';
/** Thứ 2 – Thứ 7: số liệu báo cáo công việc cho thấy công ty không làm Chủ nhật. */
const WORK_DAYS = [0, 1, 2, 3, 4, 5];
/**
 * Mặc định: mốc «Vào làm» 08:30 có chuông — đúng giờ chuông chấm công chủ dự án đặt hôm 03/10. Mốc «Ra
 * về» để sẵn nhưng TẮT: chưa ai nói công ty tan làm lúc mấy giờ, đoán sai là cả công ty bị ghi «về sớm».
 */
export const DEFAULT_ATTENDANCE = {
    slots: [
        {
            id: 'vao',
            title: 'Vào làm',
            time: '08:30',
            kind: 'in',
            days: WORK_DAYS,
            bell: true,
            enabled: true,
        },
        {
            id: 'ra',
            title: 'Ra về',
            time: '17:30',
            kind: 'out',
            days: WORK_DAYS,
            bell: false,
            enabled: false,
        },
    ],
    graceMinutes: 0,
    exempt: [],
    startDay: ATTENDANCE_START_DAY,
    networks: [],
    appOnly: true,
};
export const ATTENDANCE_LIMITS = {
    slots: 6,
    title: 40,
    graceMinutes: 120,
    exempt: 500,
    networks: 20,
    /** Lý do đi muộn. */
    reason: 200,
    /** Ghi chú của quản lý cho một người một ngày (cột «Ghi chú» của bảng theo dõi giờ làm việc). */
    note: 300,
    /** Một lần đọc lịch sử chấm công (từ ngày – đến ngày) dài tối đa ngần này ngày — một quý. */
    rangeDays: 92,
};
/**
 * Mã mốc: chữ thường, số, gạch ngang, tối đa 24 ký tự — chuông của mốc mang nhãn «cc-<mã>» làm `Topic`
 * của Web Push, mà `Topic` dài tối đa 32 ký tự.
 */
const SLOT_ID = /^[a-z0-9-]{1,24}$/;
/** «HH:MM» → số phút từ đầu ngày; `null` khi không phải giờ hợp lệ. */
export function attendanceMinutes(time) {
    const match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(time);
    return match ? Number(match[1]) * 60 + Number(match[2]) : null;
}
/** Số phút trong ngày → «08:05». */
export function formatClock(minutes) {
    const safe = Math.max(0, Math.min(24 * 60 - 1, Math.floor(minutes)));
    return `${String(Math.floor(safe / 60)).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`;
}
/** «08:30» → «8h30» — cách nói giờ trong câu thông báo, giống lịch nhắc. */
export function spokenClock(time) {
    const minutes = attendanceMinutes(time);
    if (minutes === null)
        return time;
    return `${Math.floor(minutes / 60)}h${String(minutes % 60).padStart(2, '0')}`;
}
/** Lý do một mốc chưa dùng được, hoặc `null`. Dùng cho cả ô nhập ở Cài đặt lẫn lúc đọc dữ liệu. */
export function findSlotProblem(slot) {
    if (!SLOT_ID.test(slot.id))
        return 'Mã mốc chấm công không hợp lệ';
    if (attendanceMinutes(slot.time) === null)
        return 'Giờ phải theo dạng HH:MM';
    if (!slot.title.trim())
        return 'Chưa có tên mốc';
    if (slot.title.length > ATTENDANCE_LIMITS.title)
        return 'Tên mốc quá dài';
    if (slot.kind !== 'in' && slot.kind !== 'out')
        return 'Mốc phải là «vào» hoặc «ra»';
    if (!slot.days.length)
        return 'Chưa chọn ngày nào trong tuần';
    return null;
}
/** Lý do cả bộ giờ chấm công chưa lưu được, hoặc `null`. */
export function findAttendanceProblem(settings) {
    if (settings.slots.length > ATTENDANCE_LIMITS.slots) {
        return `Tối đa ${ATTENDANCE_LIMITS.slots} mốc chấm công`;
    }
    const ids = new Set();
    for (const slot of settings.slots) {
        const problem = findSlotProblem(slot);
        if (problem)
            return `${slot.title || slot.time}: ${problem}`;
        if (ids.has(slot.id))
            return `${slot.title}: trùng mã với mốc khác`;
        ids.add(slot.id);
    }
    // Hai mốc đang bật cùng một giờ, cùng một thứ thì không chia được lần chấm nào thuộc mốc nào.
    const enabled = settings.slots.filter((slot) => slot.enabled);
    for (const [index, slot] of enabled.entries()) {
        const clash = enabled
            .slice(index + 1)
            .find((other) => other.time === slot.time && other.days.some((day) => slot.days.includes(day)));
        if (clash)
            return `«${slot.title}» và «${clash.title}» trùng giờ ${slot.time}`;
    }
    if (!Number.isInteger(settings.graceMinutes) ||
        settings.graceMinutes < 0 ||
        settings.graceMinutes > ATTENDANCE_LIMITS.graceMinutes) {
        return `Phút cho phép phải từ 0 tới ${ATTENDANCE_LIMITS.graceMinutes}`;
    }
    if (!ISO_DAY.test(settings.startDay))
        return 'Ngày bắt đầu tính chấm công không hợp lệ';
    if (settings.networks.length > ATTENDANCE_LIMITS.networks) {
        return `Tối đa ${ATTENDANCE_LIMITS.networks} mạng công ty`;
    }
    const bad = settings.networks.find((entry) => normalizeNetwork(entry) === null);
    if (bad !== undefined)
        return `«${bad}» không phải địa chỉ mạng hợp lệ`;
    return null;
}
const ISO_DAY = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const copyDefaults = () => ({
    slots: DEFAULT_ATTENDANCE.slots.map((slot) => ({ ...slot, days: [...slot.days] })),
    graceMinutes: DEFAULT_ATTENDANCE.graceMinutes,
    exempt: [...DEFAULT_ATTENDANCE.exempt],
    startDay: DEFAULT_ATTENDANCE.startDay,
    networks: [...DEFAULT_ATTENDANCE.networks],
    appOnly: DEFAULT_ATTENDANCE.appOnly,
});
function readSlot(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return null;
    const raw = value;
    const text = (field) => (typeof field === 'string' ? field.trim() : '');
    const days = Array.isArray(raw.days)
        ? [...new Set(raw.days.filter((d) => Number.isInteger(d) && d >= 0 && d <= 6))]
        : [];
    const slot = {
        id: text(raw.id),
        title: text(raw.title),
        time: text(raw.time),
        kind: raw.kind === 'out' ? 'out' : 'in',
        days: days.sort((a, b) => a - b),
        // Chỉ `true` tường minh mới bật chuông; chỉ `false` tường minh mới là tắt mốc.
        bell: raw.bell === true,
        enabled: raw.enabled !== false,
    };
    return findSlotProblem(slot) ? null : slot;
}
/**
 * Đọc khoá `chamCong` của bản ghi cài đặt. Không phải đối tượng → mặc định. Dòng mốc hỏng thì bỏ, trùng
 * mã thì giữ dòng đầu; số phút cho phép lạ thì về 0.
 */
export function readAttendanceSettings(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return copyDefaults();
    const raw = value;
    const defaults = copyDefaults();
    let slots = defaults.slots;
    if (Array.isArray(raw.slots)) {
        const seen = new Set();
        slots = [];
        for (const item of raw.slots) {
            const slot = readSlot(item);
            if (!slot || seen.has(slot.id))
                continue;
            seen.add(slot.id);
            slots.push(slot);
            if (slots.length >= ATTENDANCE_LIMITS.slots)
                break;
        }
    }
    const grace = raw.graceMinutes;
    const graceMinutes = typeof grace === 'number' &&
        Number.isInteger(grace) &&
        grace >= 0 &&
        grace <= ATTENDANCE_LIMITS.graceMinutes
        ? grace
        : 0;
    const exempt = Array.isArray(raw.exempt)
        ? [
            ...new Set(raw.exempt.filter((name) => typeof name === 'string' && name !== '')),
        ].slice(0, ATTENDANCE_LIMITS.exempt)
        : [];
    const startDay = typeof raw.startDay === 'string' && ISO_DAY.test(raw.startDay)
        ? raw.startDay
        : defaults.startDay;
    const networks = Array.isArray(raw.networks)
        ? [
            ...new Set(raw.networks
                .map((entry) => (typeof entry === 'string' ? normalizeNetwork(entry) : null))
                .filter((entry) => entry !== null)),
        ].slice(0, ATTENDANCE_LIMITS.networks)
        : [];
    // Chỉ `false` tường minh mới tắt: khoá vắng mặt (cài đặt lưu trước luật này) vẫn là bật.
    const appOnly = raw.appOnly !== false;
    return { slots, graceMinutes, exempt, startDay, networks, appOnly };
}
// ------------------------------------------------------------------ thiết bị chấm công
/**
 * Điện thoại, theo chuỗi User-Agent trình duyệt gửi kèm mọi yêu cầu: máy Android, iPhone. iPad đời mới
 * tự xưng là máy Mac nên không lọt — chủ dự án nói «điện thoại».
 */
export function isPhoneUserAgent(userAgent) {
    return /android|iphone|ipod/i.test(userAgent);
}
/**
 * Thiết bị này có được BẤM chấm công không. Luật «chỉ chấm trên app điện thoại» tắt thì ở đâu cũng được;
 * bật thì máy phải là điện thoại, và trang phải đang chạy như APP mở từ màn hình chính chứ không phải một
 * thẻ trình duyệt. Chỉ trang web tự biết điều thứ hai (`fromApp`), máy chủ tin lời nó như tin User-Agent:
 * đây là nội quy của công ty, không phải ổ khoá chống người cố tình giả.
 *
 * `fromApp` VẮNG MẶT = app bản cũ (trước luật này) chưa biết gửi — chỉ xét User-Agent, để điện thoại còn
 * chạy bản cũ trong lúc chờ tải bản mới không bị chặn oan.
 */
export function punchDeviceAllowed(settings, device) {
    if (!settings.appOnly)
        return true;
    return isPhoneUserAgent(device.userAgent) && device.fromApp !== false;
}
/** Các mốc ĐANG BẬT của một thứ trong tuần, theo giờ tăng dần. Rỗng = ngày đó không phải chấm công. */
export function slotsForWeekday(settings, weekday) {
    return settings.slots
        .filter((slot) => slot.enabled && slot.days.includes(weekday))
        .sort((a, b) => (attendanceMinutes(a.time) ?? 0) - (attendanceMinutes(b.time) ?? 0));
}
/** Ai phải chấm công: mọi NHÂN SỰ (trừ Giám đốc, Người xem — `isPersonnel`) chưa được miễn ở Cài đặt. */
export function needsAttendance(user, settings) {
    return isPersonnel(user.role) && !settings.exempt.includes(user.username);
}
/** Người này có phải chấm công NGÀY `day` («YYYY-MM-DD») không: phải chấm công, và đã tới ngày bắt đầu. */
export function attendanceRequiredOn(user, settings, day) {
    return needsAttendance(user, settings) && day >= settings.startDay;
}
const asPunch = (input) => typeof input === 'number'
    ? { minutes: input, seconds: 0, kind: null }
    : { minutes: input.minutes, seconds: input.seconds ?? 0, kind: input.kind ?? null };
/** Giây từ đầu ngày — để so hai lần chấm và tính trễ / sớm chính xác tới giây. */
const punchSeconds = (punch) => punch.minutes * 60 + punch.seconds;
/** Ngày đã qua: mọi mốc đều đã tới hạn. */
export const DAY_OVER = 24 * 60;
/** Ngày chưa tới: chưa mốc nào tới hạn. */
export const DAY_AHEAD = -1;
/**
 * Chấm công của MỘT ngày theo từng mốc. `slots` là mốc của ngày ấy (`slotsForWeekday`), `punches` là
 * các lần chấm (giờ Việt Nam), `now` là phút hiện tại nếu là HÔM NAY — ngày đã qua thì `DAY_OVER`, ngày chưa
 * tới thì `DAY_AHEAD`.
 *
 * Lần chấm CÓ ghi loại (vào / ra) chỉ về mốc CÙNG LOẠI — bấm «Ra ca» lúc 08:20 không bao giờ thành giờ vào;
 * nhiều mốc cùng loại (vào sáng, vào chiều) thì chia theo điểm giữa các mốc ấy với nhau. Lần chấm KHÔNG ghi loại
 * (bản cũ) chia theo điểm giữa hai mốc kề nhau bất kể loại. Mốc vào lấy lần SỚM NHẤT, mốc ra lấy lần MUỘN NHẤT
 * («Ra ca (giờ về mới)» của bản bàn giao: bấm ra lần nữa là giờ về mới).
 */
export function evaluateDay(slots, punches, graceMinutes, now) {
    const times = slots.map((slot) => attendanceMinutes(slot.time) ?? 0);
    const list = punches.map(asPunch);
    return slots.map((slot, index) => {
        const time = times[index] ?? 0;
        // Ranh giới với mốc kề bên là điểm giữa hai mốc; mốc đầu / cuối trải tới đầu / cuối ngày.
        const previous = times[index - 1];
        const next = times[index + 1];
        const from = previous === undefined ? -Infinity : (previous + time) / 2;
        const to = next === undefined ? Infinity : (time + next) / 2;
        // Cùng ranh giới ấy nhưng chỉ giữa các mốc CÙNG LOẠI — cho lần chấm có ghi loại.
        const sameKind = slots.flatMap((other, position) => other.kind === slot.kind ? [position] : []);
        const rank = sameKind.indexOf(index);
        const previousSame = times[sameKind[rank - 1] ?? -1];
        const nextSame = times[sameKind[rank + 1] ?? -1];
        const kindFrom = previousSame === undefined ? -Infinity : (previousSame + time) / 2;
        const kindTo = nextSame === undefined ? Infinity : (time + nextSame) / 2;
        const inside = list.filter((punch) => {
            const at = punchSeconds(punch) / 60;
            if (punch.kind)
                return punch.kind === slot.kind && at >= kindFrom && at < kindTo;
            return at >= from && at < to;
        });
        let chosen = null;
        for (const punch of inside) {
            if (chosen === null ||
                (slot.kind === 'in'
                    ? punchSeconds(punch) < punchSeconds(chosen)
                    : punchSeconds(punch) > punchSeconds(chosen))) {
                chosen = punch;
            }
        }
        if (chosen === null) {
            // Mốc vào: quá giờ (cả phút cho phép) mà chưa chấm là thiếu. Mốc ra: còn chấm được tới hết khoảng của mốc.
            const due = slot.kind === 'in' ? now > time + graceMinutes : now >= Math.min(to, DAY_OVER);
            return { slot, minutes: null, status: due ? 'missing' : 'pending', deviation: 0 };
        }
        // Trễ / sớm tính tới giây rồi làm tròn LÊN phút (bản bàn giao: 08:32 là «Đi trễ (2 phút)», 08:30:01 đã trễ).
        const offSeconds = slot.kind === 'in' ? punchSeconds(chosen) - time * 60 : time * 60 - punchSeconds(chosen);
        const deviation = Math.ceil(offSeconds / 60);
        if (deviation > graceMinutes) {
            return {
                slot,
                minutes: chosen.minutes,
                status: slot.kind === 'in' ? 'late' : 'early',
                deviation,
            };
        }
        return { slot, minutes: chosen.minutes, status: 'ok', deviation: 0 };
    });
}
/**
 * Lần chấm MỚI (`now`: phút, giây, loại) có làm một mốc VÀO thành «đi trễ» không — có thì người chấm phải ghi lý do
 * (chủ dự án, 05/10/2026: «nếu bạn nào chấm muộn sẽ báo bên cạnh và kèm lý do đi muộn»). Trả số phút trễ, 0 = không
 * trễ. Chỉ tính khi lần mới ĐÚNG LÀ lần được tính cho mốc: đã chấm vào đúng giờ rồi bấm thêm thì không hỏi; bấm
 * «Ra ca» thì không bao giờ hỏi.
 */
export function lateMinutesOfNewPunch(slots, existing, now, graceMinutes) {
    const punch = asPunch(now);
    if (punch.kind === 'out')
        return 0;
    const before = evaluateDay(slots, existing, graceMinutes, punch.minutes);
    const after = evaluateDay(slots, [...existing, punch], graceMinutes, punch.minutes);
    for (const [index, result] of after.entries()) {
        if (result.slot.kind === 'in' &&
            result.status === 'late' &&
            result.minutes === punch.minutes &&
            before[index]?.minutes === null) {
            return result.deviation;
        }
    }
    return 0;
}
/**
 * Lời trạng thái của một mốc theo bản bàn giao 07/10/2026: mốc vào «Đúng giờ» / «Đi trễ (n phút)», mốc ra «Đúng
 * giờ (Tan làm)» / «Về sớm (n phút)»; chưa chấm là «Chưa chấm» (đã quá giờ) hoặc «Chưa tới giờ».
 */
export function slotStatusLabel(result, 
/** Đơn xin đi muộn của ngày ấy đã được duyệt — trễ «có phép». */
excused = false) {
    switch (result.status) {
        case 'ok':
            return result.slot.kind === 'in' ? 'Đúng giờ' : 'Đúng giờ (Tan làm)';
        case 'late':
            return `Đi trễ (${result.deviation} phút)${excused ? ' · có phép' : ''}`;
        case 'early':
            return `Về sớm (${result.deviation} phút)`;
        case 'missing':
            return 'Chưa chấm';
        default:
            return 'Chưa tới giờ';
    }
}
// ------------------------------------------------------------------ dấu tay của quản lý
export const ATTENDANCE_MARKS = ['X', 'P', 'K', 'CT', 'L'];
export const ATTENDANCE_MARK_LABELS = {
    X: 'Có đi làm (chấm bù)',
    P: 'Nghỉ phép',
    K: 'Nghỉ không phép',
    CT: 'Công tác',
    L: 'Nghỉ lễ',
};
export const isAttendanceMark = (value) => ATTENDANCE_MARKS.includes(value);
export const DAY_CODE_LABELS = {
    X: 'Đi làm',
    M: 'Đi trễ',
    S: 'Về sớm',
    T: 'Thiếu lần chấm',
    V: 'Vắng, chưa rõ lý do',
    P: 'Nghỉ phép',
    'P/2': 'Nghỉ nửa ngày có phép',
    K: 'Nghỉ không phép',
    CT: 'Công tác',
    L: 'Nghỉ lễ',
};
/**
 * Những lần chấm đem đi xét các mốc còn lại của ngày nghỉ một buổi. Nghỉ buổi SÁNG mà buổi chiều không có mốc
 * vào nào: lần chấm đầu ngày (bản cũ, không ghi loại) là lúc TỚI làm, không phải lúc ra về — bỏ nó ra khỏi việc
 * xét mốc ra, không thì người vừa tới lúc 13:20 bị tính «về sớm».
 */
export function judgedPunches(slots, punches, leave) {
    if (leave !== 'morning' || slots.some((slot) => slot.kind === 'in'))
        return [...punches];
    const sorted = [...punches].sort((a, b) => punchSeconds(asPunch(a)) - punchSeconds(asPunch(b)));
    // Lần chấm có ghi loại tự về đúng mốc của nó — chỉ lần chấm bản cũ (không loại) mới phải bỏ bớt.
    const first = sorted[0];
    return first !== undefined && asPunch(first).kind === null ? sorted.slice(1) : sorted;
}
/**
 * Tổng kết một ngày. Dấu tay của quản lý thắng tất cả; rồi tới nghỉ phép đã duyệt: cả ngày là «P», một buổi
 * thì các mốc trong buổi ấy không xét nữa và ô là «P/2»; đơn xin đi muộn đã duyệt thì muộn không thành «M».
 */
export function summarizeDay(input) {
    const leave = input.leave ?? null;
    const slots = leave
        ? input.slots.filter((slot) => !minutesInSession(attendanceMinutes(slot.time) ?? 0, leave))
        : input.slots;
    const results = evaluateDay(slots, judgedPunches(slots, input.punches, leave), input.graceMinutes, input.now);
    const workday = input.slots.length > 0;
    const late = results
        .filter((result) => result.status === 'late')
        .reduce((sum, result) => sum + result.deviation, 0);
    const lateExcused = late > 0 && input.lateExcused === true;
    const earlyMinutes = results
        .filter((result) => result.status === 'early')
        .reduce((sum, result) => sum + result.deviation, 0);
    const base = {
        workday,
        leave,
        lateMinutes: lateExcused ? 0 : late,
        earlyMinutes,
        lateExcused,
        slots: results,
    };
    const quiet = { lateMinutes: 0, earlyMinutes: 0, lateExcused: false };
    if (input.mark)
        return { ...base, ...quiet, code: input.mark, marked: true };
    if (!workday)
        return { ...base, code: input.punches.length ? 'X' : null, marked: false };
    if (leave === 'full')
        return { ...base, ...quiet, code: 'P', marked: false };
    if (leave)
        return { ...base, code: 'P/2', marked: false };
    if (!input.punches.length) {
        const missed = results.some((result) => result.status === 'missing');
        return { ...base, code: missed ? 'V' : null, marked: false };
    }
    let code = 'X';
    if (late > 0 && !lateExcused)
        code = 'M';
    else if (results.some((result) => result.status === 'early'))
        code = 'S';
    else if (results.some((result) => result.status === 'missing'))
        code = 'T';
    return { ...base, code, marked: false };
}
export function monthTotals(days) {
    const totals = {
        worked: 0,
        late: 0,
        excusedLate: 0,
        lateMinutes: 0,
        early: 0,
        incomplete: 0,
        absent: 0,
        leave: 0,
        unpaid: 0,
        business: 0,
        holiday: 0,
    };
    for (const day of days) {
        switch (day.code) {
            case 'X':
                totals.worked += 1;
                break;
            case 'M':
                totals.worked += 1;
                totals.late += 1;
                break;
            case 'S':
                totals.worked += 1;
                totals.early += 1;
                break;
            case 'T':
                totals.worked += 1;
                totals.incomplete += 1;
                break;
            case 'CT':
                totals.worked += 1;
                totals.business += 1;
                break;
            case 'V':
                totals.absent += 1;
                break;
            case 'P':
                totals.leave += 1;
                break;
            case 'P/2':
                totals.worked += 0.5;
                totals.leave += 0.5;
                break;
            case 'K':
                totals.unpaid += 1;
                break;
            case 'L':
                totals.holiday += 1;
                break;
            default:
                break;
        }
        totals.lateMinutes += day.lateMinutes;
        if (day.lateExcused)
            totals.excusedLate += 1;
    }
    return totals;
}
// ------------------------------------------------------------------ chuông nhắc
/** Mã của chuông một mốc trong sổ chống bắn trùng (`push_reminder_runs`) và nhãn gộp thông báo. */
export const attendanceBellId = (slot) => `cc-${slot.id}`;
/** Mốc tới giờ đổ chuông lúc này: có chuông, đã tới giờ nhưng chưa quá `graceMinutes`, hôm nay chưa đổ. */
export function dueAttendanceBells(slots, minutes, alreadySent, graceMinutes) {
    return slots.filter((slot) => {
        if (!slot.bell || alreadySent.has(attendanceBellId(slot)))
            return false;
        const at = attendanceMinutes(slot.time);
        return at !== null && minutes >= at && minutes - at <= graceMinutes;
    });
}
/** Nội dung chuông của một mốc: «Đã 8h30 — bạn chưa chấm công vào làm hôm nay.» */
export function attendanceBellMessage(slot) {
    const what = slot.title.trim().toLocaleLowerCase('vi');
    return slot.kind === 'in'
        ? {
            title: 'Chấm công',
            body: `Đã ${spokenClock(slot.time)} — bạn chưa chấm công ${what} hôm nay.`,
        }
        : { title: 'Chấm công', body: `Đã ${spokenClock(slot.time)} — nhớ bấm chấm công ${what}.` };
}
//# sourceMappingURL=attendance.js.map